import { AbstractControl } from '@angular/forms';
import { isString } from 'util';

export class BasicEventDataValidator {

  static dateCompare(formControl: AbstractControl): { [key: string]: boolean } | null {
    let startDate = formControl.get('startDate').value;
    let endDate = formControl.get('endDate').value;

    if (!startDate || !endDate) {
      return null;
    } else {
      // Convert to string if object
      if (!isString(startDate)) {
        startDate = startDate.toUTCString();
      }

      if (!isString(endDate)) {
        endDate = endDate.toUTCString();
      }
    }

    const isInvalid = new Date(startDate) >= new Date(endDate);

    if (isInvalid) {
      formControl.get('endDate').markAsTouched();
      return { 'greater': true };
    }

    return null;
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/basic-event-data/basic-event-data.validator.ts